import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=5f71f45a&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"
import style0 from "./Summary.vue?vue&type=style&index=0&id=5f71f45a&prod&lang=css"
import style1 from "./Summary.vue?vue&type=style&index=1&id=5f71f45a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f71f45a",
  null
  
)

export default component.exports